// es.js — PunchLog Spanish locale
// Natural, labor-law-aware Spanish.
// Key terms: "horas extras" (not "tiempo extra"), "período de pago" (not "período de salario"),
//   "registro de entrada/salida" for clock-in/out, "turno" for shift.
// Do NOT translate: PunchLog, version strings, HMAC, ECDSA, IndexedDB, format strings.
export default {

  // ── AppShell ──────────────────────────────────────────────────────────────
  shell_tagline:            'Datos Laborales Verificados',
  shell_navAriaLabel:       'Navegación principal',
  shell_sidebarAriaLabel:   'Navegación principal',
  shell_online:             'En línea',
  shell_offline:            'Sin conexión',
  shell_switchToLight:      'Cambiar a modo claro',
  shell_switchToDark:       'Cambiar a modo oscuro',
  shell_collapseSidebar:    'Contraer barra lateral',
  shell_expandSidebar:      'Expandir barra lateral',
  shell_syncedAgo:          'Sincronizado {n}',
  shell_syncedJustNow:      'ahora mismo',
  shell_syncedMinutes:      'hace {n} min',
  shell_syncedHours:        'hace {n} h',
  shell_tabTrack:           'Registrar',
  shell_tabPlanner:         'Planificador',
  shell_tabScan:            'Escanear',
  shell_tabSettings:        'Ajustes',

  // ── EntryList ─────────────────────────────────────────────────────────────
  entry_filterAll:          'Todos',
  entry_filterShift:        'Turno',
  entry_filterTravel:       'Viaje',
  entry_filterOnCall:       'Guardia',
  entry_filterJobSearch:    'Búsqueda de empleo',
  entry_allWorkplaces:      'Todos los lugares de trabajo',
  entry_groupConcurrent:    'Agrupar simultáneos',
  entry_showVariance:       'Variación de horario',
  entry_varianceHint:       '{n}h vs programado',
  entry_predictiveViolation: 'Violación de horario predictivo (<24h de aviso)',
  entry_colVariance:        'Variación',
  entry_clearFilters:       'Limpiar',

  entry_emptyTitle:         'Aún no hay registros',
  entry_emptyTitleFiltered: 'Sin registros coincidentes',
  entry_emptySub:           'Haz un registro de entrada en la pestaña Registrar para comenzar a anotar tu tiempo.',
  entry_emptySubFiltered:   'Intenta limpiar los filtros anteriores.',

  entry_colDate:            'Fecha',
  entry_colIn:              'Entrada',
  entry_colOut:             'Salida',
  entry_colHours:           'Horas',
  entry_colType:            'Tipo',
  entry_colWorkplace:       'Lugar de trabajo',
  entry_colJob:             'Puesto',
  entry_colStatus:          'Estado',

  entry_typeShift:          'turno',
  entry_typeTravel:         'viaje',
  entry_typeOnCall:         'guardia',
  entry_typeJobSearch:      'búsqueda de empleo',
  entry_concurrentBadge:    '{n}× simultáneos',

  entry_statusOk:           'OK',
  entry_statusSealed:       'Sellado',
  entry_signedLock:         'Firmado: registro inmutable',
  entry_statusModified:     'Modificado',

  entry_concurrentHeading:  '{n} actividades simultáneas, duración total {hours}h',
  entry_concurrentHint:     'Cambia a la vista dividida para editar o eliminar registros individuales.',
  entry_segColIn:           'Entrada',
  entry_segColOut:          'Salida',
  entry_segColHours:        'Horas',
  entry_segColType:         'Tipo',
  entry_segColJob:          'Puesto',

  entry_groupEntries:       '{n} registro · {hours}h | {n} registros · {hours}h',

  entry_dlBreak:            'Descanso',
  entry_breakUnpaid:        '{n} min no remunerados',
  entry_dlJob:              'Puesto',
  entry_dlCreated:          'Creado',
  entry_dlModified:         'Modificado',
  entry_dlNotes:            'Notas',

  entry_editDate:           'Fecha',
  entry_editClockIn:        'Registro de entrada',
  entry_editClockOut:       'Registro de salida',
  entry_editBreak:          'Descanso (min)',
  entry_editType:           'Tipo',
  entry_editTypeShift:      'Turno',
  entry_editTypeTravel:     'Viaje',
  entry_editTypeOnCall:     'Guardia',
  entry_editTypeJobSearch:  'Búsqueda de empleo',
  entry_editJobTitle:       'Puesto de trabajo',
  entry_editJobPlaceholder: 'p. ej. Cocinero de línea',
  entry_editNotes:          'Notas',
  entry_btnSave:            'Guardar',
  entry_btnCancel:          'Cancelar',
  entry_btnEdit:            'Editar',
  entry_btnDelete:          'Eliminar',

  entry_deleteConfirm:      '¿Eliminar este registro? Esta acción no se puede deshacer.',
  entry_deleteBtnConfirm:   'Sí, eliminar',

  entry_selectRow:          'Seleccionar fila',
  entry_bulkToggle:         'Selección múltiple',
  entry_bulkSelected:       '{n} seleccionados',
  entry_bulkDelete:         'Eliminar seleccionados',
  entry_bulkClear:          'Limpiar selección',
  entry_bulkWp:             'Cambiar lugar de trabajo…',
  entry_bulkWpLabel:        'Lugar de trabajo masivo',
  entry_bulkType:           'Cambiar tipo…',
  entry_bulkTypeLabel:      'Tipo de entrada masivo',
  entry_bulkApply:          'Aplicar',
  entry_colCostCode:        'Código',

  // ── PlannerPanel ─────────────────────────────────────────────────────────
  planner_importTitle:      'Importar',
  planner_importDesc:       'Acepta JSON, CSV o Excel (.xls SpreadsheetML) exportados desde PunchLog. Cada fila se convierte en un registro de tiempo.',
  planner_chooseFile:       'Elegir archivo…',
  planner_importedSuccess:  'Se importó {n} registro. | Se importaron {n} registros.',
  planner_xlsxError:        '.xlsx no es compatible. Exporta como .xls o CSV desde PunchLog y vuelve a importar.',

  planner_exportTitle:      'Exportar',
  planner_exportDolLabel:   'Informe de horas',
  planner_exportDolSub:     'PDF con todas tus horas y registros',
  planner_exportInvoiceLabel: 'Factura PDF',
  planner_exportInvoiceSub: 'PDF de factura de horas facturables',
  planner_exportCsvLabel:   'CSV',
  planner_exportCsvSub:     'Valores separados por comas, se abre en Excel y Numbers',
  planner_exportExcelLabel: 'Excel',
  planner_exportExcelSub:   'SpreadsheetML, formato .xls nativo',
  planner_exportJsonLabel:  'JSON',
  planner_exportJsonSub:    'Historial de auditoría completo con todos los campos',

  planner_exportGroupTimeEntries: 'Registros de tiempo',
  planner_exportGroupSchedules:   'Horarios',
  planner_exportSchedCsvLabel:    'Horario (CSV)',
  planner_exportSchedCsvSub:      'fecha, empleado, lugar, horas de entrada/salida',
  planner_exportSchedExcelLabel:  'Horario (Excel)',
  planner_exportSchedExcelSub:    'SpreadsheetML, compatible con importación',
  planner_includeSeal:     'Incluir sello criptográfico',
  planner_includeSealHint: 'Agrega el token JWS o aviso de sin firma al PDF',
  planner_destLabel:       'Guardar en',
  planner_destLocal:       'Descargar',
  planner_destDrive:       'Guardar en Drive',
  planner_destDriveHint:   'Conecta Google Drive en Ajustes para habilitar',
  planner_driveSaved:      'Guardado en Google Drive',
  planner_driveUploading:  'Subiendo {name}…',
  planner_driveError:      'Error al subir. Revisa tu conexión e inténtalo de nuevo.',
  planner_moreFormats:     'Más formatos',

  planner_btnExport:        'Exportar…',
  planner_btnImport:        'Importar…',

  planner_sectionSummary:   'Resumen',
  planner_statPeriod:       'Período',
  planner_statWorkplace:    'Lugar de trabajo',
  planner_statTotalHours:   'Horas totales',
  planner_statEstPay:       'Pago est.',
  planner_statDays:         'Días',
  planner_statOtDays:       'Días con HE',
  planner_statModified:     'Modificados',
  planner_statUnsigned:     'Sin sellar',

  planner_mobileTotalHours: '{n}h totales',
  planner_mobileDays:       '{n} días',
  planner_mobileOt:         '{n} HE',
  planner_mobileUnsigned:   '{n} sin sellar',

  planner_sectionPeriod:    'Período',
  planner_filterThisWeek:   'Esta semana',
  planner_filterThisMonth:  'Este mes',
  planner_filterAll:        'Todos',
  planner_filterCustom:     'Personalizado',
  planner_dateRangeSep:     'hasta',
  planner_customFrom:       'Fecha inicio',
  planner_customTo:         'Fecha fin',

  planner_sectionWorkplace: 'Lugar de trabajo',
  planner_sectionType:      'Tipo de entrada',
  planner_sectionGroupBy:   'Agrupar por',
  planner_groupNone:        'Ninguno',
  planner_groupDay:         'Día',
  planner_groupWeek:        'Semana',
  planner_groupShift:       'Turno',
  planner_groupMonth:       'Mes',
  planner_invoiceGrouping:  'Ítems por',
  planner_invoiceFrom:      'De (perfil de facturación)',
  planner_invoiceFromDefault: 'Perfil predeterminado',
  planner_invoiceNoProfile: 'Agrega un perfil de facturación en Ajustes para mostrar tu nombre y dirección en las facturas.',
  planner_invoiceLimitReached: 'Límite de facturas del nivel gratuito alcanzado (5/mes). Mejora a Pro para facturas ilimitadas.',
  planner_groupHint:        'Se aplica al cambiar a la vista de lista',

  planner_sectionAdd:       'Agregar',
  planner_addLogEntry:      'Registrar entrada',
  planner_addSchedule:      'Horario',

  planner_entryFormDate:    'Fecha',
  planner_entryFormIn:      'Entrada',
  planner_entryFormOut:     'Salida',
  planner_entryFormBreak:   'Descanso',
  planner_entryFormPlace:   'Lugar',
  planner_entryBtnSaved:    '¡Guardado!',
  planner_entryBtnSaving:   'Guardando…',
  planner_entryBtnSave:     'Guardar registro',

  planner_schedFormName:    'Nombre',
  planner_schedFormNamePlaceholder: 'p. ej. Lun–Vie 9–17',
  planner_schedFormStart:   'Inicio',
  planner_schedFormEnd:     'Fin',
  planner_schedFormDays:    'Días',
  planner_schedFormBreak:   'Descanso',
  planner_schedBtnSaved:    '¡Guardado!',
  planner_schedBtnSaving:   'Guardando…',
  planner_schedBtnSave:     'Guardar horario',
  planner_schedBtnApply:    'Aplicar al rango',
  planner_rosterBizOnly:    'La importación de plantillas requiere el plan Business.',

  planner_dowSu:            'Do',
  planner_dowM:             'Lu',
  planner_dowTu:            'Ma',
  planner_dowW:             'Mi',
  planner_dowTh:            'Ju',
  planner_dowF:             'Vi',
  planner_dowSa:            'Sa',

  planner_viewList:         'Lista',
  planner_viewTimesheet:    'Hoja de tiempo',
  planner_viewCalendar:     'Calendario',
  planner_unsignedSeal:     '{n} sin sellar',

  // ── Timesheet grid ────────────────────────────────────────────────────────
  ts_addCode:                'Agregar código',
  ts_noCodesTitle:           'Sin códigos de costo configurados',
  ts_noCodesSub:             'Agregue un código abajo o configure códigos en la configuración del lugar de trabajo.',
  ts_codePlaceholder:        'CÓDIGO',
  ts_labelPlaceholder:       'Etiqueta',
  ts_wpGroup:                '{name}',
  ts_week:                   'Semana',
  ts_total:                  'Total',
  planner_timesheetWeekTotal: 'Semana',
  planner_timesheetTotal:    'Total',
  planner_timesheetAutosave: 'Guardar automáticamente',
  planner_timesheetSaveAll:  'Guardar todo',
  planner_calMode3Day:       '3 días',
  planner_calModeWorkWeek:   'Semana laboral',
  planner_calModeWeek:       'Semana',
  planner_calModeMonth:      'Mes',
  planner_calNavToday:       'Hoy',

  // ── CalendarGrid ─────────────────────────────────────────────────────────
  calendar_prevMonth:       'Mes anterior',
  calendar_nextMonth:       'Mes siguiente',
  calendar_dowSun:          'Dom',
  calendar_dowMon:          'Lun',
  calendar_dowTue:          'Mar',
  calendar_dowWed:          'Mié',
  calendar_dowThu:          'Jue',
  calendar_dowFri:          'Vie',
  calendar_dowSat:          'Sáb',
  calendar_hoursLogged:     '{n}h',
  calendar_hoursPlanned:    '{n}h planificadas',
  calendar_hoursOf:         'de {n}h',
  calendar_entryCount:      '{n} registros',
  calendar_legendWorked:    'Trabajado',
  calendar_legendOt:        'HE >8h',
  calendar_legendScheduled: 'Programado',
  calendar_legendIssue:     'Modificado/Sin firma',

  // ── WorkplaceConfig ───────────────────────────────────────────────────────
  config_sectionWorkplaces: 'Lugares de trabajo',
  config_unnamed:           'Sin nombre',
  config_noWorkplaces:      'Aún no hay lugares de trabajo. Agrega uno abajo.',
  config_btnAddWorkplace:   'Agregar lugar de trabajo',

  config_sectionSchedules:  'Plantillas de horario',
  config_noSchedules:       'Aún no hay plantillas',
  config_btnAddTemplate:    'Agregar plantilla',

  config_sectionBillingProfiles: 'Perfiles de facturación',
  config_noBillingProfiles:      'Aún no hay perfiles de facturación',
  config_btnAddBillingProfile:   'Agregar perfil',
  config_defaultWorkplaceName:   'Mi lugar de trabajo',
  config_unitPerHour:            '/h',
  config_newBillingProfile:      'Nuevo perfil de facturación',
  config_editBillingProfile:     'Editar perfil de facturación',
  config_bpIdentityHeader:       'Identidad',
  config_deleteBpConfirm:        '¿Eliminar este perfil de facturación?',
  config_bpAddressHeader:        'Dirección',
  config_bpPreferencesHeader:    'Preferencias',
  config_bpName:                 'Nombre',
  config_bpNamePlaceholder:      'p. ej. Acme S.A. o Juan García',
  config_bpNameHint:             'Aparece como el campo De en las facturas',
  config_bpEmail:                'Correo electrónico',
  config_bpEmailPlaceholder:     'dirección de correo de facturación',
  config_bpDefault:              'Perfil predeterminado',
  config_bpDefaultHint:          'Usar este perfil cuando no se seleccione ninguno',

  config_sectionAppSettings: 'Ajustes de la aplicación',
  config_dataPrivacy:       'Datos y privacidad',
  config_dataPrivacySub:    'Exportar, borrar registros, almacenamiento',
  config_syncCloud:         'Sincronización y nube',
  config_syncCloudSub:      'Copia de seguridad y sincronización en la nube',
  sync_chooseHint:          'Elige un proveedor de nube para sincronizar tus datos entre dispositivos.',
  sync_googleDrive:         'Google Drive',
  sync_oneDrive:            'OneDrive',
  sync_statusConnecting:    'Conectando…',
  sync_statusExpired:       'Sesión expirada',
  sync_statusSyncing:       'Sincronizando…',
  sync_statusError:         'Error',
  sync_statusConnected:     'Conectado',
  sync_btnReconnect:        'Reconectar',
  sync_lastSync:            'Última sincronización: {time}',
  sync_btnSyncNow:          'Sincronizar ahora',
  sync_btnDisconnect:       'Desconectar',
  sync_bpDefault:           'predeterminado',
  config_planFeatures:      'Plan y funciones',
  config_integrations:      'Integraciones',
  config_integrationsSub:   'Webhooks, eventos salientes',
  config_teams:             'Equipos',
  config_teamsSub:          'Lugares de trabajo con varios miembros',

  config_newWorkplace:      'Nuevo lugar de trabajo',
  config_editWorkplace:     'Editar lugar de trabajo',

  config_identityHeader:    'Identificación',
  config_addressHeader:     'Dirección',
  config_workplaceName:              'Nombre',
  config_workplaceNamePlaceholder:   'p. ej. Bistró del Centro',
  config_workplaceNamePlaceholderContract: 'p. ej. Acme Corp – Fase 1',
  config_workplaceNameHint:          'Use un nombre único por empleador o contrato',
  config_employerLegalName:          'Nombre de la entidad legal',
  config_employerLegalNamePlaceholder: 'Para registros oficiales',
  config_employerLegalNameHint:      'Aparece en informes exportados y facturas',
  config_address:           'Dirección',
  config_addressPlaceholder: 'Calle, ciudad, estado, código postal',
  config_address1:           'Calle',
  config_address1Placeholder: 'Av. Principal 123',
  config_address2:           'Suite / Apto',
  config_address2Placeholder: 'Suite 100',
  config_city:               'Ciudad',
  config_zip:                'Código postal',
  config_stateField:         'Estado',
  config_phone:              'Teléfono',
  config_phonePlaceholder:   '+52 (55) 0000-0000',
  config_defaultJobTitle:    'Puesto predeterminado',
  config_defaultJobTitlePlaceholder: 'p. ej. Cocinero, Ingeniero de Software',
  config_defaultJobTitleHint: 'Se rellena automáticamente en nuevos registros de este lugar de trabajo',

  config_payHeader:         'Pago',
  config_payStructure:      'Estructura salarial',
  config_payHourly:         'Por hora',
  config_paySalary:         'Salario fijo',
  config_payCommission:     'Comisión',
  config_isContract:        'Este es un contrato / trabajo independiente',

  config_hourlyRate:        'Tarifa por hora',
  config_hourlyRateHint:    'Mínimo estatal: ${min}/h',

  config_salaryAmount:         'Monto del salario',
  config_salaryAmountContract: 'Tarifa fija',
  config_salaryAmountContractHint: 'Tarifa fija periódica facturada independientemente de las horas registradas',
  config_payPeriod:            'Período de pago',
  config_payPeriodWeekly:   'Semanal',
  config_payPeriodBiweekly: 'Quincenal',
  config_payPeriodSemimonthly: 'Dos veces al mes (24×/año)',
  config_payPeriodMonthly:  'Mensual',
  config_payPeriodAnnual:   'Anual',

  config_baseRate:             'Tarifa base (opcional)',
  config_baseRateHint:         '0 = solo comisión',
  config_baseRateContract:     'Tarifa horaria base (opcional)',
  config_baseRateHintContract: 'Deje en blanco o ingrese 0 para comisión exclusiva',
  config_commissionPct:     'Comisión %',

  config_contractBilling:               'Tipo de facturación al cliente',
  config_contractBillingFixed:          'Precio fijo',
  config_contractBillingRetainer:       'Anticipo',
  config_contractBillingHourly:         'Por hora',
  config_contractRetainerPlusHourlyHint:'Base de anticipo + horas registradas facturadas encima',
  config_contractAmount:                'Monto',
  config_contractPeriod:                'Período de facturación',
  config_contractPeriodQuarterly:       'Trimestral',
  config_contractDesc:                  'Alcance / Entregable',
  config_contractDescPlaceholder:       'p. ej. Fase 1: integración de API',

  config_hoursOtHeader:     'Horas y horas extras',
  config_defaultHoursDay:          'Horas predeterminadas por día',
  config_defaultUnpaidBreak:       'Descanso no remunerado predeterminado',
  config_defaultUnpaidBreakHint:   'Se pre-llena en nuevas entradas para este lugar de trabajo',
  config_dailyOtThreshold:  'Umbral de horas extras diarias',
  config_dailyOtHint:       '0 = sin horas extras diarias',
  config_weeklyOtThreshold: 'Umbral de horas extras semanales',

  config_complianceHeader:  'Cumplimiento normativo',
  config_flsaClass:         'Clasificación FLSA',
  config_flsaNonExempt:     'No exento (con derecho a horas extras)',
  config_flsaExempt:        'Exento (salario fijo, sin horas extras)',
  config_flsaContractor:    'Contratista independiente (1099)',
  config_flsaTrainee:       'Aprendiz / becario',

  config_stateOtRules:      'Estado (normas de horas extras)',
  config_timeRounding:      'Redondeo de tiempo',
  config_roundNone:         'Ninguno (exacto)',
  config_roundNearest15:    'Al cuarto de hora más cercano',
  config_roundUp15:         'Redondear hacia arriba 15 min',
  config_roundDown15:       'Redondear hacia abajo 15 min',
  config_roundingHint:      'Se aplica a las horas de entrada y salida',

  config_costCodesHeader:   'Códigos de costo',
  config_costCodesLabel:    'Códigos activos para este lugar de trabajo',
  config_costCodesHint:     'Se muestran los predeterminados; editor por lugar de trabajo próximamente',

  config_btnSave:           'Guardar',
  config_btnDelete:         'Eliminar',
  config_btnCancel:         'Cancelar',
  config_btnSaving:         'Guardando…',
  config_btnSaveChanges:    'Guardar cambios',
  config_savedMsg:          'Guardado',

  config_newScheduleTemplate: 'Nueva plantilla de horario',
  config_editTemplate:      'Editar plantilla',
  config_scheduleHeader:    'Horario',
  config_templateName:      'Nombre de la plantilla',
  config_templateNamePlaceholder: 'p. ej. Lun–Vie 9–17',
  config_linkedWorkplace:   'Lugar de trabajo vinculado',
  config_linkedWorkplaceAny: 'Cualquiera',
  config_daysOfWeek:        'Días de la semana',
  config_startTime:         'Hora de inicio',
  config_endTime:           'Hora de fin',
  config_unpaidBreak:       'Descanso no remunerado',
  config_btnSaveTemplate:   'Guardar plantilla',

  config_noDaysScheduled:   'Sin días',
  config_dayMon:            'Lun',
  config_dayTue:            'Mar',
  config_dayWed:            'Mié',
  config_dayThu:            'Jue',
  config_dayFri:            'Vie',
  config_daySat:            'Sáb',
  config_daySun:            'Dom',

  config_dataHeader:        'Datos y privacidad',
  config_exportSectionHeader: 'Exportar',
  config_exportDesc:        'Descarga una copia completa de todos los datos locales en JSON: lugares de trabajo, horarios y cada registro de tiempo, incluyendo el historial de auditoría completo.',
  config_btnExportAll:      'Exportar todos los datos (JSON)',
  config_dangerZone:        'Zona de peligro',
  config_clearDesc:         'Elimina permanentemente todos los registros de tiempo locales. Los ajustes de lugares de trabajo y las plantillas de horario no se verán afectados. Esta acción no se puede deshacer.',
  config_btnClearRecords:   'Borrar registros de tiempo',

  config_clearTimeLabel:    'Borrar registros de tiempo',
  config_clearTimeDesc:     'Elimina todas las entradas de turnos. Los lugares de trabajo, horarios y perfiles de facturación se conservan.',
  config_clearTimeConfirm:  'Todas las entradas de tiempo se eliminarán permanentemente. Los ajustes de trabajo y facturación no se ven afectados.',

  config_clearWorkplacesLabel:   'Eliminar lugares de trabajo y horarios',
  config_clearWorkplacesDesc:    'Elimina todos los lugares de trabajo, plantillas de horario y turnos programados. Los registros de tiempo se conservan.',
  config_clearWorkplacesConfirm: 'Todos los lugares de trabajo, plantillas de horario y turnos programados se eliminarán permanentemente. Los registros de tiempo no se ven afectados.',
  config_btnClearWorkplaces:     'Eliminar lugares de trabajo',

  config_clearBillingLabel:    'Eliminar perfiles de facturación',
  config_clearBillingDesc:     'Elimina todos los perfiles de facturación. Los registros de tiempo y lugares de trabajo se conservan.',
  config_clearBillingConfirm:  'Todos los perfiles de facturación se eliminarán permanentemente.',
  config_btnClearBilling:      'Eliminar perfiles de facturación',

  config_resetAllLabel:    'Restablecer todo',
  config_resetAllDesc:     'Borra todos los datos locales: registros de tiempo, lugares de trabajo, horarios, perfiles de facturación y paquetes firmados. Empieza desde cero.',
  config_resetAllConfirm:  'Todos los datos locales se borrarán permanentemente, incluidos los paquetes de auditoría firmados. Esta acción no se puede deshacer.',
  config_btnResetAll:      'Restablecer todos los datos locales',

  config_sheetImportHeader:   'Importar desde Google Sheets',
  config_sheetImportDesc:     'Pega un enlace a una hoja de cálculo de Google con datos de entradas de tiempo. La primera fila debe ser el encabezado.',
  config_sheetUrlLabel:       'URL de la hoja',
  config_sheetUrlPlaceholder: 'https://docs.google.com/spreadsheets/d/…',
  config_sheetConflict:       'Cuando una entrada importada se superpone con una existente',
  config_sheetConflictSkip:   'Omitir (conservar existente)',
  config_sheetConflictOver:   'Sobrescribir existente',
  config_sheetConflictKeep:   'Conservar ambas',
  config_sheetDefaultWp:      'Asignar a lugar de trabajo (opcional)',
  config_sheetDefaultWpNone:  'Sin lugar de trabajo',
  config_sheetBtnImport:      'Importar entradas',
  config_sheetConnectHint:    'Conecta Google Drive en Ajustes → Sincronización para habilitar la importación.',
  config_sheetImporting:      'Importando…',
  config_sheetDone:           'Listo: {imported} importadas, {skipped} omitidas.',
  config_sheetErrors:         '{count} fila(s) con errores.',
  config_sheetBadUrl:         'No se encontró un ID de hoja en esa URL.',

  config_dangerExportHint: 'Opcionalmente, exporta una copia de seguridad primero; puedes reimportarla más tarde.',
  config_btnCancel:        'Cancelar',
  config_btnConfirmDelete: 'Eliminar',
  config_aboutHeader:       'Acerca de',
  config_aboutVersion:      'Versión',
  config_aboutStorage:      'Almacenamiento',
  config_aboutStorageValue: 'En el dispositivo (IndexedDB)',
  config_aboutServerSync:   'Sincronización con servidor',
  config_aboutServerSyncValue: 'Ninguna (Plan gratuito)',
  config_aboutAuditTrail:   'Historial de auditoría',
  config_aboutAuditTrailValue: 'Inmutable, solo local',

  config_planHeader:        'Plan y funciones',
  config_planFree:          'Gratis',
  config_planSoon:          'Próximamente',
  config_planPerMonth:      '/mes',
  config_planCurrentBadge:  'Actual',
  config_planUpgrade:       'Actualizar',

  config_integrationsHeader: 'Integraciones',
  config_webhookWarning:    'Los webhooks requieren una suscripción Pro. Configúralos ahora: los eventos se encolan hasta que actualices.',
  config_webhookHeader:     'Endpoint del webhook',
  config_webhookDesc:       'PunchLog envía un POST firmado a tu URL en cada evento. Verifica las solicitudes con el encabezado X-PunchLog-Signature HMAC-SHA256.',
  config_webhookUrlLabel:   'URL del endpoint',
  config_webhookUrlPlaceholder: 'https://ejemplo.com/webhook',
  config_webhookUrlHint:    'Debe ser HTTPS en producción',
  config_webhookSecretLabel: 'Secreto de firma',
  config_webhookSecretPlaceholder: 'Cadena aleatoria, ≥ 32 caracteres',
  config_webhookSecretHint: 'Se usa para calcular X-PunchLog-Signature. Mantenlo privado.',
  config_btnSaveWebhook:    'Guardar',
  config_btnTestPayload:    'Probar payload',
  config_btnRemoveWebhook:  'Eliminar',
  config_webhookSaved:      'Guardado.',
  config_emittedEventsHeader: 'Eventos emitidos',

  config_evtGroupEntries:   'Registros de tiempo',
  config_evtShiftCreated:   'Nuevo registro de tiempo guardado',
  config_evtShiftUpdated:   'Registro de tiempo editado',
  config_evtShiftDeleted:   'Registro de tiempo eliminado',
  config_evtShiftSigned:    'Lote sellado con firma criptográfica',
  config_evtGroupWorkplaces: 'Lugares de trabajo',
  config_evtWpCreated:      'Nueva configuración de lugar de trabajo agregada',
  config_evtWpUpdated:      'Ajustes del lugar de trabajo modificados',
  config_evtWpDeleted:      'Lugar de trabajo eliminado',
  config_evtGroupSchedules: 'Horarios',
  config_evtSchedCreated:   'Nueva plantilla de horario guardada',
  config_evtSchedUpdated:   'Plantilla de horario editada',
  config_evtSchedDeleted:   'Plantilla de horario eliminada',
  config_evtGroupInvoices:  'Facturas y exportaciones',
  config_evtInvoiceCreated: 'Factura generada',
  config_evtDataExported:   'Exportación completa de datos descargada',
  config_evtGroupSync:      'Sincronización',
  config_evtSyncQueued:     'Registro almacenado localmente mientras estaba sin conexión',
  config_evtSyncFlushed:    'Cola pendiente enviada tras reconectarse',
  config_evtGroupOcr:       'OCR',
  config_evtScanCreated:    'Escaneo de documento OCR guardado',

  config_teamsHeader:       'Equipos',
  config_teamsComingSoon:   'Próximamente',
  config_teamsSoonDesc:     'Equipos permite que varios miembros compartan un lugar de trabajo y da a los gerentes una vista de auditoría de solo lectura, sin compartir credenciales.',
  config_teamsFeature1:     'Hasta 25 miembros por lugar de trabajo',
  config_teamsFeature2:     'Visibilidad compartida del horario',
  config_teamsFeature3:     'Panel de auditoría para gerentes',
  config_teamsFeature4:     'Acceso por roles: Administrador y Miembro',

  config_deleteWorkplaceConfirm: '¿Eliminar {name}? Esta acción no se puede deshacer.',
  config_deleteScheduleConfirm:  '¿Eliminar {name}?',
  config_clearRecordsConfirm:    '¿Eliminar todos los registros de tiempo locales? Esta acción no se puede deshacer.',

  // ── ShiftView ─────────────────────────────────────────────────────────────
  shift_firstRunTitle:      'Bienvenido a PunchLog',
  shift_firstRunDesc:       'Registra tu tiempo, protege tu salario y exporta hojas de horas a prueba de manipulaciones, todo en tu dispositivo.',
  shift_firstRunStep1:      'Agrega un lugar de trabajo (tu empleador o cliente)',
  shift_firstRunStep2:      'Registra entrada cuando comienza tu turno',
  shift_firstRunStep3:      'Exporta una hoja de horas cuando la necesites',
  shift_noWorkplaceBanner:  'No hay lugar de trabajo configurado.',
  shift_addDefault:         'Agregar uno predeterminado',
  shift_createOne:          'Crear uno',
  shift_advancedSetup:      'Configuración avanzada →',

  shift_newWorkplaceTitle:  'Nuevo lugar de trabajo',
  shift_wpNameLabel:        'Nombre',
  shift_wpNamePlaceholder:  'p. ej. Diner Acme',
  shift_wpRateLabel:        'Tarifa por hora ($/h)',
  shift_wpDefaultHours:     'Horas predeterminadas por día',
  shift_btnCancelModal:     'Cancelar',
  shift_btnSaveModal:       'Guardar',

  shift_exportTitle:        'Exportar',
  shift_exportDolTitle:     'Informe de horas',
  shift_exportDolSub:       'PDF firmado con tus horas y registros',
  shift_exportInvoiceTitle: 'Factura PDF',
  shift_exportInvoiceSub:   'Factura al cliente con horas × tarifa',

  shift_modeLive:           'Reloj en vivo',
  shift_modeManual:         'Entrada manual',

  shift_fieldWorkplace:     'Lugar de trabajo',
  shift_selectWorkplace:    'Seleccionar lugar de trabajo',
  shift_btnAddWorkplace:    'Agregar lugar de trabajo',
  shift_fieldEntryType:     'Tipo de registro',
  shift_typeShift:          'Turno',
  shift_typeWork:           'Sesión de trabajo',
  shift_typeTravel:         'Viaje',
  shift_typeOnCall:         'Guardia',
  shift_typeJobSearch:      'Búsqueda de empleo',

  shift_fieldJobTitle:      'Puesto de trabajo',
  shift_jobTitlePlaceholder: 'p. ej. Cocinero de línea',
  shift_fieldRateOfPay:     'Tarifa salarial',
  shift_fieldSchedule:      'Plantilla de horario',
  shift_scheduleNone:       'Ninguno',

  shift_fieldDate:          'Fecha',
  shift_fieldClockIn:       'Registro de entrada',
  shift_fieldClockOut:      'Registro de salida',
  shift_clockInRounded:     '→ redondeado a {time}',

  shift_fieldUnpaidBreak:   'Descanso no remunerado',
  shift_breakNone:          'Ninguno',
  shift_break15:            '15 min',
  shift_break30:            '30 min',
  shift_break45:            '45 min',
  shift_break60:            '1 h',
  shift_breakCustom:        'Personalizado',
  shift_breakHint:          'Se descuenta de las horas remuneradas',
  shift_breakPlaceholder:   'min',

  shift_fieldNotes:         'Notas',
  shift_notesPlaceholder:   'Opcional…',

  shift_btnClockIn:         'Registrar entrada',
  shift_btnClockOut:        'Registrar salida',
  shift_idleHint:           'Selecciona un lugar de trabajo y tipo en el formulario, luego registra la entrada.',

  shift_manualPreviewTitle: 'Vista previa de entrada manual',
  shift_manualEstPay:       'Est. {pay}',
  shift_manualEnterTimes:   'Ingresa los horarios en el formulario',
  shift_previewGross:       'Tiempo bruto',
  shift_previewCompensable: 'Tiempo remunerado',
  shift_previewOvertime:    'Horas extras',
  shift_previewEstPay:      'Pago est.',
  shift_btnReset:           'Restablecer',
  shift_btnSaving:          'Guardando…',
  shift_btnSaveEntry:       'Guardar registro',
  shift_entrySaved:         'Registro guardado',

  shift_sectionTodayActivity: 'Actividad de hoy',
  shift_compensableToday:   'Horas remuneradas hoy',
  shift_travel:             'Viaje',
  shift_spread:             'Jornada extendida',

  shift_sectionThisWeek:    'Esta semana',
  shift_sectionSignExport:  'Exportar',
  shift_totalHours:         'Horas totales',
  shift_daysWorked:         'Días trabajados',
  shift_otHours:            'Horas extras',

  shift_sectionTodayEntries: 'Registros de hoy',
  shift_ledgerTotal:        'Total: {hours}h remuneradas',

  shift_sectionSealExport:  'Sellar y exportar',
  shift_sealSigned:         'Sellado',
  shift_sealReady:          '{n} registro listo para sellar | {n} registros listos para sellar',
  shift_sealNone:           'No hay registros sin sellar',
  shift_noTodayActivity:    'Sin actividad hoy',
  shift_noManualEntries:    'Sin entradas manuales',
  shift_sealAuditTrail:     'Historial de auditoría verificable',
  shift_btnSigning:         'Sellando…',
  shift_btnResign:          'Volver a sellar',
  shift_btnSign:            'Sellar ({n})',
  shift_btnExport:          'Exportar',

  shift_otWarning:          'HE: {hours}h a 1,5× aplica',

  // ── OcrView ───────────────────────────────────────────────────────────────
  ocr_parsedResult:         'Resultado analizado',
  ocr_btnImportToTrack:     'Importar a Registrar',
  ocr_btnClear:             'Limpiar',
  ocr_scanning:             'Escaneando…',
  ocr_tapToScan:            'Toca para escanear',
  ocr_btnScanDocument:      'Escanear documento',
  ocr_btnUploadDocument:    'Subir documento',

  ocr_sectionDocType:       'Tipo de documento',
  ocr_typePayStub:          'Recibo de nómina',
  ocr_typeTimesheet:        'Parte de horas',
  ocr_typePunchCard:        'Tarjeta de fichaje',
  ocr_typeSchedule:         'Horario',

  ocr_sectionExtracts:      'Campos extraídos',
  ocr_extractEmpName:       'Nombre del empleador',
  ocr_extractPayPeriod:     'Período de pago',
  ocr_extractGrossPay:      'Salario bruto',
  ocr_extractNetPay:        'Salario neto',
  ocr_extractHourlyRate:    'Tarifa por hora',
  ocr_extractHoursWorked:   'Horas trabajadas',
  ocr_extractDateRange:     'Rango de fechas',
  ocr_extractDailyHours:    'Horas diarias',
  ocr_extractTotalHours:    'Horas totales',
  ocr_extractOvertime:      'Horas extras',
  ocr_extractEmployeeName:  'Nombre del empleado',
  ocr_extractPunchIn:       'Horas de fichaje de entrada',
  ocr_extractPunchOut:      'Horas de fichaje de salida',
  ocr_extractDate:          'Fecha',
  ocr_extractShiftTimes:    'Horario del turno',
  ocr_extractDaysOfWeek:    'Días de la semana',
  ocr_extractPosition:      'Cargo / función',
  ocr_extractLocation:      'Ubicación',

  ocr_privacyBanner:        'El OCR se ejecuta en el dispositivo. Ningún dato del documento sale de tu teléfono.',

  ocr_sectionRecentScans:   'Escaneos recientes',
  ocr_noScansYet:           'Aún no hay escaneos',
  config_locationSingular:  'ubicación',
  config_locationPlural:    'ubicaciones',
  config_templateSingular:  'plantilla',
  config_templatePlural:    'plantillas',
  config_profileSingular:   'perfil',
  config_profilePlural:     'perfiles',
  ocr_tabScan:              'Escanear',
  ocr_tabRecent:            'Recientes',
}
